import React, { Fragment, useState, useRef, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/Modal/index'
import moment from 'moment'

const ViewModalContainer = ({
    currentItem, 
    toggleView, 
  }) => { 

    const [hasScroll,setHasScroll] = useState(false)
    const dpRef = useRef(null)
    useLayoutEffect(() => {
        setTimeout(() => {
          
            const hasScroll = dpRef.current.clientHeight < dpRef.current.scrollHeight
            setHasScroll(hasScroll)
        }, 20)
    }, [])


     const renderDepositPositions = (item) => <span style={{color: "#3C3738"}} key={item.idIrcSupplyStorageBin} className='supply-list-deposit-position'>{`${item.warehouseType} - ${item.storageBinId}`}</span>

    return (
        <Modal
        className="irc-supply-new-view-modal"
        title={"Visualizar lista"}
        confirmButtonText={"Fechar"}
        hideCancelButton
        disabledBgClickClosing
        isOpen
        size={'md'}
        onCloseModal={() => toggleView(false)}
        center
        onConfirm={() => toggleView(false)}
      >
        <Fragment>
       
            <div  className='irc-supply-list-new-modal'>
            
              <div className='supply-left-spacer supply-section list-name-section'>
                <span>Nome da lista</span>
                <span>{currentItem.listDescription}</span>
              </div>

              <div className=' supply-left-spacer supply-section list-branch-section'>
                <span>Loja</span>
                <span style={{textTransform:"capitalize"}}>{currentItem.idStore} - {currentItem.dsStore.replace("LOJA", "").toLowerCase()}</span>
              </div>

              <div className='supply-left-spacer list-period-qtd-section'>
                <div>
                  <span>Período</span>
                  <span>{`${moment(currentItem.dtBegin).format('DD/MM/YYYY')} - ${moment(currentItem.dtEnd).format('DD/MM/YYYY')}`}</span>
                </div>

                <div style={{paddingRight:32, width:200}}>
                  <span>Posições por dia</span>
                  <span>{currentItem.qtdList}</span>
                </div>

              </div>
              <div className='supply-section list-positions-section'>
                <span>Depósitos e posições</span>
                <div ref={dpRef} id={'teste'} className={`deposit-positions ${hasScroll ? 'deposit-positions-border' : ''}`}>
                  {currentItem.storageBinList.map(item => renderDepositPositions(item))}
                </div>
              </div>
                
           </div>
          
        </Fragment>
      </Modal>
    )
  }

  ViewModalContainer.propTypes = {
    user: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    currentItem: PropTypes.object,
    toggleView: PropTypes.func,
    toggleEdit: PropTypes.func,
    toggleUpload: PropTypes.func,

  }

export {ViewModalContainer}